import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="show-hide-link"
// a controller that gets an element as target that is hidden by default
// it can have any number of links that will show/hide the target
export default class extends Controller {
  connect() {
  }

  static get targets() {
    return ['target']
  }

  toggle(event) {
    event.preventDefault()
    const wasVisible = !this.targetTargets[0]?.hidden

    this.targetTargets.forEach((target) => {
      target.hidden = !target.hidden
    })

    if (wasVisible) {
      this.element.scrollIntoView({ block: 'start' })
    }
  }
}
